import { ReactNode } from 'react';
import { usePermissionContext } from '../contexts/PermissionContext';
import type { PermissionKey } from '../types/permissions';

interface PermissionGateProps {
  permission: PermissionKey;
  children: ReactNode;
  fallback?: ReactNode;
  loadingFallback?: ReactNode;
}

export function PermissionGate({ permission, children, fallback, loadingFallback }: PermissionGateProps) {
  const { loading, hasPermission } = usePermissionContext();

  if (loading) return <>{loadingFallback ?? null}</>;
  if (!hasPermission(permission)) return <>{fallback ?? null}</>;
  return <>{children}</>;
}
